export default __webpack_public_path__ + "static/media/offrole_employees.3217e704.png";